import { CORE_SERVICE_URL } from "@coworker/app/src/hooks/API/core.service";
import { NewTeamDataType } from "../types/TeamMutationTypes";
import { getTokenAsync } from "@coworker/app/src/hooks/API/getAuthToken";
import { makeServiceHeaders } from "@coworker/app/src/core/hooks/fetch.helpers";

async function addTeam(newTeamData: NewTeamDataType) {
  const token = await getTokenAsync();
  const headers = await makeServiceHeaders();
  const url = `${CORE_SERVICE_URL}/teams`;
  const body = JSON.stringify(newTeamData);

  if (!token || typeof token !== "string") {
    console.error("No valid auth token found");
  }

  const result = await fetch(url, {
    method: "POST",
    headers,
    body,
  });

  if (!result.ok) {
    const errorDetails = await result.text();
    console.error(
      `Failed to add team: ${result.status} ${result.statusText}. Details: ${errorDetails}`
    );
  }

  return result;
}

export default addTeam;
